// extracted by mini-css-extract-plugin
export default {"card":"Contact_card__TObSU","actions":"Contact_actions__LPCF4"};